import { useMemo } from 'react';

import { Study } from '@/api/model';
import { usePriorStudies } from '@/shared/hook';

export function useFctPreviousStudies() {
  const {
    currentStudy,
    hasPreviousStudyResults,
    isError,
    mostRecentPreviousStudy,
    previousStudyResults,
  } = usePriorStudies();

  return useMemo(
    () => ({
      currentStudy,
      hasPreviousStudyResults,
      isError,
      mostRecentPreviousStudy,
      previousStudyResults,
      studies: [] as Study[],
    }),
    [currentStudy, hasPreviousStudyResults, isError, mostRecentPreviousStudy, previousStudyResults],
  );
}
